module.exports = __webpack_public_path__ + "img/qr-kxwj.33045be9.png";